import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "p-m-0" }, "Reportes", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" No hay talentos todavía. ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Cargando... ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DataTable, {
      value: _ctx.allTalents,
      paginator: true,
      dataKey: "id",
      rowHover: true,
      loading: _ctx.loading,
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      currentPageReportTemplate: "Viendo {first} a {last} de {totalRecords} talentos",
      globalFilterFields: ['name', 'state'],
      filters: _ctx.filters,
      "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters = $event)),
      rows: 10,
      showGridlines: "",
      responsiveLayout: "scroll",
      ref: "talentsTable",
      exportFilename: "Usuarios de CoderTalent"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              icon: "pi pi-download",
              label: "Descargar reporte",
              class: "p-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exportCSV($event)))
            })
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _hoisted_3
      ]),
      loading: _withCtx(() => [
        _hoisted_4
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          header: "Nombre completo",
          sortable: "",
          field: "name"
        }),
        _createVNode(_component_Column, {
          header: "Email",
          sortable: "",
          field: "email"
        }),
        _createVNode(_component_Column, {
          header: "Pais",
          sortable: "",
          field: "country"
        }),
        _createVNode(_component_Column, {
          header: "Localidad",
          sortable: "",
          field: "city"
        }),
        _createVNode(_component_Column, {
          header: "Documento",
          sortable: "",
          field: "dni"
        }),
        _createVNode(_component_Column, {
          header: "Expertise",
          sortable: "",
          field: "expertise"
        }),
        _createVNode(_component_Column, {
          header: "Sector de la industria",
          sortable: "",
          field: "industryPreference"
        }),
        _createVNode(_component_Column, {
          header: "Idiomas",
          sortable: "",
          field: "languages"
        }),
        _createVNode(_component_Column, {
          header: "Habilidades",
          sortable: "",
          field: "skills"
        }),
        _createVNode(_component_Column, {
          header: "Modalidades de trabajo",
          sortable: "",
          field: "workModalities"
        })
      ]),
      _: 1
    }, 8, ["value", "loading", "filters"])
  ]))
}